import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default (
  <Route key="/business/user/sign-in" element={<DefaultBusinessLayout />}>
    <Route path="business/user/sign-in" element={<AsyncPage />} />
  </Route>
);
